import { type ReactNode } from 'react';
import { NotificationToast, NotificationToastAction, Severity } from '@sib/ui';
import { toast } from 'sonner';

export const ERROR_TOASTER_ID = 'error';
export const NON_ERROR_TOASTER_ID = 'non-error';

export const TOAST_TOP_OFFSET_PX = 70;
export const TOAST_RIGHT_OFFSET_PX = 20;
export const TOAST_STACK_GAP_PX = 14;

type ToastOptions = {
  id?: string | number;
  description?: ReactNode;
  isExtension?: boolean;
  duration?: number;
  action?: NotificationToastAction;
  closeAlign?: 'center' | 'top';
};

export const getToasterIdForSeverity = (variant: Severity) =>
  variant === ERROR_TOASTER_ID ? ERROR_TOASTER_ID : NON_ERROR_TOASTER_ID;

export const createToast =
  (variant: Severity) => (message: string, opts?: ToastOptions) =>
    toast.custom(
      () => (
        <NotificationToast
          variant={variant}
          title={message}
          isExtension={opts?.isExtension}
          description={opts?.description || ''}
          onClose={() => {
            toast.dismiss(opts?.id);
          }}
          action={opts?.action}
          closeAlign={opts?.closeAlign}
        />
      ),
      {
        id: opts?.id,
        duration: opts?.duration,
        toasterId: getToasterIdForSeverity(variant),
      }
    );
